export enum IconVariationEnum {
  UP = "up",
  DOWN = "down",
  EQUAL = "equal"
}

export const ICON_VARIATION = {
  [IconVariationEnum.UP]: "up",
  [IconVariationEnum.DOWN]: "down",
};

export enum InsightsFeedbackEnum {
  POSITIVE = "positive",
  NEGATIVE = "negative",
  NEUTRAL = "neutral",
}

export const INSIGHT_FEEDBACK = {
  [InsightsFeedbackEnum.POSITIVE]: "positive",
  [InsightsFeedbackEnum.NEGATIVE]: "negative",
  [InsightsFeedbackEnum.NEUTRAL]: "neutral",
};

export const InsightsFeedbackColor = {
  [InsightsFeedbackEnum.POSITIVE]: "#BDEFCE",
  [InsightsFeedbackEnum.NEGATIVE]: "#FFC7C7",
  [InsightsFeedbackEnum.NEUTRAL]: "#EDF1F7",
};

export enum EDownloadFormat {
  CSV = 1,
  PNG = 2,
  PDF = 3,
}